'use client';
import { AnalyticsBrowser } from '@segment/analytics-next';
import { createContext } from 'react';

type pageViewIds = {
  newPageViewId: string;
  previousPageViewId: string;
};
export interface AnalyticsContextProps {
  analytics: AnalyticsBrowser | null;
  pageName?: string;
  pageViewId?: string;
  oldPageViewId?: string;
  generateNewPageViewId?: () => pageViewIds;
  updatePageName?: (pageName: string) => string;
  updatePageViewId?: (pageViewId: string) => {
    newPageViewId: string;
    previousPageViewId: string;
  };
}

const defaultAnalyticsContext = {
  analytics: new AnalyticsBrowser(),
};

export const AnalyticsContext = createContext<AnalyticsContextProps>(
  defaultAnalyticsContext,
);

export interface SkuImpressionContextProps {
  skuImpressionId: string;
}

const defaultSkuImpressionContextValue: SkuImpressionContextProps = {
  skuImpressionId: null,
};

export const SkuImpressionContext = createContext<SkuImpressionContextProps>(
  defaultSkuImpressionContextValue,
);
